import { Outlet } from "react-router-dom";
import "../../assets/images/mim-logo.png";

import NavbarHeader from "../../components/Headers/NavbarHeader";
import SidePanel from "../../components/SidePanel/SidePanel";
import styles from "./Layout.module.css";

const Layout = (props) => {
  return (
    <>
      <main className="mainContainer">
        <div id="aSideContainer">
          <SidePanel />
        </div>
        <div id="contentContainer">
          <div id="header" className={styles.header}>
            <NavbarHeader />
          </div>
          <div id="content">
            <Outlet />
          </div>
        </div>
      </main>
    </>
  );
};

export default Layout;
